s<template>
	<div id="retrieve-quote">
		<div v-show="show=='options'">
			<initial-account @loggedIn="loggedIn" @social="socialLogin" :register="false"></initial-account>
		</div>
		<div v-show="show=='existing-quotes'">
			<div class="modal-title">
			    <h3>
			      Existing Quotes
			    </h3>
			  </div>

			  <div class="existing-quotes mt-5" :class="{'h-52': isLoading}">
			  	<div v-if="!isLoading">
					<div v-if="quotes && quotes.length > 0">
						<div class="bg-white shadow overflow-hidden sm:rounded-md">
						  <div class="divide-y divide-gray-200">
						    <div v-for="quote in quotes">
						      <a href="#" class="block no-underline hover:bg-gray-50" @click="selectQuote(quote)">
						        <div class="flex items-center px-4 py-4 sm:px-6">
						          <div class="min-w-0 flex-1 flex items-center">
						            <div class="min-w-0 flex-1 px-4">
						              <div>
						                <p class="text-sm font-medium text-gray-500 truncate">Quoted: {{ quote.coverStartFormat }}</p>
						                <p class="mt-2 flex items-center text-teal-600">
						                  <span class="truncate text-xl">£{{ quote.client_premium }}</span>
						                  <i class="fas fa-circle mx-2 text-xs text-gray-300"></i>
						                  <span class="text-xl">Bikes: {{ quote.covered.length }}</span>
						                </p>
						              </div>
						            </div>
						          </div>
						          <div>
						            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
						              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
						            </svg>
						          </div>
						        </div>
						      </a>
						    </div>
						  </div>
						</div>

						<div class="pagination">
						  <div class="flex-1 flex justify-between sm:hidden">
						    <a href="#" class="prev-btn" :class="{'disabled': currPage == 1}" @click="prevPage(true)">
						      Previous
						    </a>
						    <a href="#" class="next-btn" :class="{'disabled': currPage == lastPage}" @click="nextPage(true)">
						      Next
						    </a>
						  </div>
						  <div class="pagination-container">
						    <div>
						      <p class="text-sm text-gray-700 my-2 text-center">
						        Showing
						        <span class="font-medium">{{ from }}</span>
						        to
						        <span class="font-medium">{{ to }}</span>
						        of
						        <span class="font-medium">{{ total }}</span>
						        results
						      </p>
						    </div>
						    <div class="flex">
						      <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination" v-if="lastPage > 5">
						        <a href="#" class="page-nav rounded-l-md" @click="prevPage" :class="{'disabled':pagePrev[0] == 1}">
						          <span class="sr-only">Previous</span>
						          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
						            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
						          </svg>
						        </a>
						        <a href="#" class="page-link" :class="{'active': p == currPage}" v-for="p in showing.prev" @click="changePrevPage(p)">
						          {{ p }}
						        </a>
						        <span class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
						          ...
						        </span>
						        <a href="#" class="page-link" :class="{'active': p == currPage}" v-for="p in showing.next" @click="changeNextPage(p)">
						          {{ p }}
						        </a>
						        <a href="#" class="page-nav rounded-r-md" @click="nextPage" :class="{'disabled':pageNext[1] >= lastPage}">
						          <span class="sr-only">Next</span>
						          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
						            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
						          </svg>
						        </a>
						    </nav>
						    <nav class="relative z-0 inline-flex shadow-sm -space-x-px mx-auto" aria-label="Pagination" v-else>
					    		<a href="#" class="page-link" :class="{'active': p == currPage, 'rounded-l-md': p == 1, 'rounded-r-md': p == lastPage}" v-for="p in lastPage" @click="changePage(p)">
						          {{ p }}
						        </a>
						      </nav>
						    </div>
						  </div>
						</div>
					</div>
					<div class="mb-5" v-else>
						<no-data>No quotes found</no-data>
					</div>
				</div>
				<loading :show="isLoading"></loading>
			  </div>
		</div>
	</div>
</template>

<script>
	import initialAccount from './initial/account.vue';
	export default {
		name: 'quote.retrieve',
		components: {
			initialAccount
		},
		data() {
			return {
				show: 'options',
				isLoading: false,
				quotes: false,
				socialChecking: false,
				currPage: 1,
				lastPage: 0,
				pagePrev:[1, 2],
				pageNext:[],
				from: 0,
				to: 0,
				total: 0,
			}
		},
		computed: {
			showing() {
				let links = {
					prev: [],
					next: [],
				};

				links.prev.push(this.pagePrev[0]);
				links.prev.push(this.pagePrev[1]);

				if(this.pageNext.length == 0) {
					links.next.push(this.lastPage-1);
					links.next.push(this.lastPage);
				} else {
					links.next.push(this.pageNext[0]);
					links.next.push(this.pageNext[1]);
				}

				return links;
			}
		},
		methods: {
			getQuotes() {
				const self = this;

				self.isLoading = true;

				// register client
				Vue.axios.get('client/quotes', {
					params: {
						page: this.currPage
					}
				})
				 .then((resp) => {
				 	if(resp.data.success) {
				 		self.quotes 		= resp.data.quotes.quotes;

				 		self.lastPage 		= resp.data.quotes.links.last_page;
				 		if(self.pageNext.length == 0) {
				 			self.pageNext = [self.lastPage-1, self.lastPage];
				 		}

				 		self.from 	= resp.data.quotes.links.from;
				 		self.to 	= resp.data.quotes.links.to;
				 		self.total 	= resp.data.quotes.links.total;
				 	}

		 			// stop loading gif
		 			self.isLoading = false;
				 })
				 .catch((error) => {
				 	// stop loading
				 	self.isLoading = false;
				 })
			},
			loggedIn() {
				this.show = 'existing-quotes';

				this.getQuotes();
			},
			socialLogin(e) {

				const self = this;

				if(!self.socialChecking) {
					self.socialChecking = true;

					Vue.axios.get('client/loggedIn')
							 .then((loggedIn) => {
							 	self.socialChecking = false;

							 	if(loggedIn) {
							 		// Stop interval & close popup
							 		clearInterval(e.check);
							 		e.popup.close();

							 		// Move to next step & load existing quotes
							 		self.loggedIn();
							 	}
						 })
				}
			},
			changePage(p) {
				this.currPage = p;

				this.getQuotes();
			},
			changePrevPage(p) {
				this.currPage 		= p;

				if(p+1 < this.pageNext[0]) {
					this.pagePrev 		= [p, p+1];
				}

				this.getQuotes();
			},
			changeNextPage(p) {
				this.currPage 		= p;

				if(p-1 > this.pagePrev[1]) {
					this.pageNext 		= [p-1, p];
				}

				this.getQuotes();
			},
			nextPage(mobile = false) {
				if((mobile && this.currPage < this.lastPage) || this.pageNext[1] < this.lastPage) {
					this.pageNext = [(this.pageNext[0]+1), (this.pageNext[1]+1)];
					
					this.currPage++;
					this.getQuotes();
				}

			},
			prevPage(mobile = false) {
				if((mobile && this.currPage > 1) || this.pagePrev[0] > 1) {
					this.pagePrev = [(this.pagePrev[0]-1), (this.pagePrev[1]-1)];
					
					this.currPage--;
					this.getQuotes();
				}
			},
			selectQuote(q) {
				const self = this;

				self.isLoading = true;

				Vue.axios.get('quote/select/'+q.quote_id)
					     .then((resp) => {

					     	if(resp.data.success) {
						 	 	window.location.href = self.baseUrl+'/quote/';
					     	}
						 })
						 .catch((error) => {
						 	self.isLoading = false;
						 })
			}
		}
	}
</script>